import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faLocationDot, faLocationPlus, faTable,
} from '@fortawesome/pro-solid-svg-icons';
import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { type TranslationFnc } from '~/_shared/utils/hooks';
import { mapToolIconMap } from '~/sidebar/sidebarApps/mapTools/mapTools.helpers';

export enum MapSearchFilterBy {
  OnlyUserData = 'OnlyUserData',
  OnlyGeolocated = 'OnlyGeolocated',
  UserDataAndGeolocated = 'UserDataAndGeolocated',
  PlacesAndPoi = 'PlacesAndPoi',
}

export const createDisplayName = (filter: MapSearchFilterBy, t: TranslationFnc): string => {
  switch (filter) {
    case MapSearchFilterBy.OnlyGeolocated:
      return t(MapSearchFilterBy.OnlyGeolocated);
    case MapSearchFilterBy.OnlyUserData:
      return t(MapSearchFilterBy.OnlyUserData);
    case MapSearchFilterBy.UserDataAndGeolocated:
      return t(MapSearchFilterBy.UserDataAndGeolocated);
    case MapSearchFilterBy.PlacesAndPoi:
      return t(MapTool.Places);
    default:
      throw new Error(`Unknown MapSearchFilterBy '${filter}'`);
  }
};

export const createFilterByIcon = (filter: MapSearchFilterBy): IconProp => {
  switch (filter) {
    case MapSearchFilterBy.OnlyUserData:
      return faTable;
    case MapSearchFilterBy.UserDataAndGeolocated:
      return faLocationPlus;
    case MapSearchFilterBy.PlacesAndPoi:
      return mapToolIconMap[MapTool.Places];
    case MapSearchFilterBy.OnlyGeolocated:
    default:
      return faLocationDot;
  }
};
